export enum MediaContentTypes {
  PICTURE = 'PICTURE',
  ANIMATION = 'ANIMATION',
  ADVERT = 'ADVERT',
}
